module.exports = __webpack_public_path__ + "img/1.aa1301a0.svg";